<!-- Maintenance Mode -->
<div *ngIf="maintenanceMode">
  <app-maintenance-v2></app-maintenance-v2>
</div>

<ng-container *ngIf="!maintenanceMode">
  <ng-content *ngIf="!applicationPage && !registrationForm && !verification && !assessment && !forgotPassword && !resetPassword && !formPreview && !ssoCallback && !loginPage && !isAiInterview">
    <div *ngIf="!candidatePanel" class="container">
      <div class="menu">
        <app-side-nav></app-side-nav>
      </div>
      <div class="main-container">
        <div class="header">
          <app-header [searchItem]="searchItem"></app-header>
        </div>
        <div class="main">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

    <div *ngIf="candidatePanel">
      <app-candidate-panel></app-candidate-panel>
    </div>
  </ng-content>
  <ng-content *ngIf="applicationPage || registrationForm || verification || assessment || forgotPassword || resetPassword || formPreview || ssoCallback || loginPage || isAiInterview">
    <router-outlet></router-outlet>
  </ng-content>
</ng-container>
<p-toast></p-toast>
